import { useGlobalOrganisationID } from "@/composables/useGlobalOrganisationID";
import { useIsMspRoute } from "@/composables/useIsMspRoute";

export const useGlobalOrganisationIDBasedOnRoute = () => {
  const { mspGlobalOrganisationId, customerGlobalOrganisationId } =
    useGlobalOrganisationID();

  const { isMspRoute } = useIsMspRoute();

  const globalOrganisationId = isMspRoute.value
    ? mspGlobalOrganisationId
    : customerGlobalOrganisationId;

  return {
    globalOrganisationId,
  };
};

export default {};
